import React, { useState, useContext } from 'react';
import Icon from 'react-icons-kit'
import { edit2 } from 'react-icons-kit/feather'
import { CiLocationOn } from "react-icons/ci";
import './style.scss';
import LocationOfGroomModal from './Modal/LocationOfGroom'
import { UserContext } from '../../utils/context/userContext';
import { Images } from '../../utils/Images';

const LocationOfGroom = (props) => {

    const [model, setModel] = useState({ show: false, loading: false })
    const { user, handleRefetch } = useContext(UserContext)
    const { birthCountry, livingCountry, stateDevision, city } = user

    return (
        <div className="detailInformations" >
            <div className="card shadow mb-4" >
                <div className="card-header px-4 pt-3 pb-0">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex align-items-end gap-2">          
                            <CiLocationOn size={23} color="#0b8c97" />
                            <h5 className="mb-0">Location Details</h5>
                        </div>
                        <div className="ml-auto">
                            <button className="btn rounded-circle shadow"
                                onClick={() => setModel({ ...model, show: true })}
                            >
                                <Icon icon={edit2} size={20} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body px-lg-5">
                    <div className="row" >
                        <div className=" col-12 col-md-6">
                            <div className='flex justify-content-between'>
                            <div className=" col-12 col-md-6">
                                <div className="my-3">
                                <small className="text-muted">Birth Country</small>
                                <div>{birthCountry ? birthCountry : "N/A"}</div>
                                 <div className="mt-3">
                                    <small className="text-muted">Living Country</small>
                                    <div>{livingCountry ? livingCountry : "N/A"}</div>
                                </div>
                            </div>
                            </div>
                            <div className=" col-12 col-md-6">
                                <div className="my-3">
                                <small className="text-muted">City</small>
                                <div>{city ? city : "N/A"}</div>
                                <div className="mt-3">
                                <small className="text-muted">State / Devision</small>
                                <div>{stateDevision ? stateDevision : "N/A"}</div>
                                </div>
                            </div>
                            </div>
                            </div>
                            {/* <div className=" col-12 col-md-6"></div> */}
                            
                           
                            
                            <table >
                                <thead>
                                    {/* <tr>
                                        <th></th>
                                        <td className="pl-5">:</td>
                                        <td ></td>
                                    </tr> */}
                                    {/* <tr>
                                        <th></th>
                                        <td className="pl-5">:</td>
                                        <td></td>
                                    </tr> */}
                                    {/* <tr>
                                        <th></th>
                                        <td className="pl-5">:</td>
                                        <td ></td>
                                    </tr> */}
                                    {/* <tr>
                                        <th>City</th>
                                        <td className="pl-md-5">:</td>
                                        <td></td>
                                    </tr> */}
                                </thead>
                            </table>
                        </div>
                        <div className="col-12 col-md-6 ">
                            <img src={Images.Location} alt=''className="img-fluid rounded"
                                style={{ maxHeight: "160px", objectFit: "cover" }} />
                        </div>
                    </div>
                </div>
            </div>
            {model.show ?
                <LocationOfGroomModal
                    show={model.show}
                    birthCountry={birthCountry}
                    livingCountry={livingCountry}
                    stateDevision={stateDevision}
                    city={city}
                    loading={model.loading}
                    handleRefetch={handleRefetch}
                    onHide={() => setModel({ ...model, show: false, loading: false })}
                />
                : null}
        </div>
    )
};

export default LocationOfGroom;